import create from 'zustand';

export type ApplyForm = {
    attributes: Array<any>;
    files: Array<any>;
};

type ApplyFormStore = {
    applyForm: ApplyForm | null;
    attributes: Array<any>;
    setApplyForm: (applyForm: ApplyForm | null) => void;
    setAttributes: (attributes: Array<any>) => void;
};

export const useApplyFormStore = create<ApplyFormStore>((set) => ({
    applyForm: null,
    attributes: [],
    setApplyForm: (applyForm) =>
        set((_) => ({
            applyForm: applyForm,
        })),
    setAttributes: (attributes) =>
        set((_) => ({
            attributes: attributes,
        })),
}));
